export enum PendingRequestType {
    Claims = "claims",
    Leaves = "leaves",
    All = "all"
}